import { useEffect, useState } from 'react';

import staticdata, { resourceCatalogList } from '@lcsc-ui/apis/staticdata';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import ecpCurl, { asyncAll, setPageBaseURL } from '@lcsc-ui/utils/ecpCurl';
import Utils from '@lcsc-ui/utils/Utils';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import ListApi from '@/apis/ListApi';
import OrderApi from '@/apis/OrderApi';
import WwwApi from '@/apis/WwwApi';
import ProductDetail from '@/features/HotProductDetail';
import { baseURL } from '@/utils/baseUrl';
import { getCatalogSchema } from '@/utils/schema';

const HotProductDetailPage = (props) => {
  const { resourceData, websiteSectionList, headerAd, productResult } = props;
  const [isLgScreen, setIsLgScreen] = useState(null);
  const [catalogList, setCatalogList] = useState(null);

  const metadata = {
    title: `热门爆款电子元器件特卖专场-立创商城`,
    description: `立创商城(SZLCSC.COM)一站式电子元器件采购自营商城，拥有13万+平米智能化仓储，现货SKU品类超50万种，原装正品，支持一键BOM配单，最快4小时发货，为用户提供一站式电子元器件线上采购服务。嘉立创集团提供“EDA软件/PCB CAM软件、PCB智造、元器件商城、 激光钢网/治具 、SMT贴片”为一体的电子全产业链服务，助力全球硬件创新。`,
    additionalMetaTags: [
      {
        name: 'keywords',
        content: `元器件,特卖专场,电子元器件`,
      },
    ],
  };

  useEffect(() => {
    resourceCatalogList().then((res) => {
      setCatalogList(res?.result);
    });
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = () => {
    setIsLgScreen(Utils.isLgScreen());
  };

  const { JsonLd, MicroData } = getCatalogSchema(productResult, resourceData, metadata.description);

  return (
    <>
      <NextSeo
        title={metadata.title}
        description={metadata.description}
        additionalMetaTags={metadata.additionalMetaTags}
      />
      <Head>
        <link rel="canonical" href={`${resourceData?.projectConfigVO?.lcscListUrl}/hot.html`} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(JsonLd) }} />
      </Head>
      {MicroData}
      <BaseLayout
        resourceData={resourceData}
        catalogList={catalogList}
        websiteSectionList={websiteSectionList}
        headerAd={headerAd}
        isLgScreen={isLgScreen}
        notIndexHeaderAdapter={true}
        isNeedTopAd={true}
        isShowBottomAd={true}
        showMemberWebsite={false}
      >
        <ProductDetail {...productResult} />
      </BaseLayout>
    </>
  );
};

export async function getStaticPaths() {
  return {
    paths: [].map((item) => ({
      params: { id: item.toString() },
    })),
    fallback: 'blocking',
  };
}

export async function getStaticProps(context) {
  setPageBaseURL(baseURL);
  const { id } = context?.params || {
    id: '',
  };
  const pageId = id.replace('.html', '');
  if (!pageId || pageId !== 'index') {
    return {
      notFound: true,
      revalidate: 1,
    };
  }

  try {
    const [
      productResult,
      defaultAddressBelongWarehouse,
      wwwStockpileHistorySwitch,
      resourceData,
      websiteSectionList,
      headerAd,
      notFound,
    ] = await asyncAll([
      ecpCurl(ListApi.hotList),
      ecpCurl(OrderApi.selectWarehouse),
      ecpCurl(WwwApi.wwwStockpileHistorySwitch),
      ecpCurl(staticdata.resourceList, { enableCache: true }),
      ecpCurl(staticdata.websiteSection, { enableCache: true }),
      ecpCurl(staticdata.advertisingHeader, { enableCache: true }),
    ]);
    if (notFound) {
      return {
        notFound: true,
        revalidate: 1,
      };
    }
    if (productResult?.searchResult) {
      productResult.searchResult.defaultAddressBelongWarehouse = defaultAddressBelongWarehouse || 'sz';
    }
    if (productResult && wwwStockpileHistorySwitch?.switch) {
      productResult.showStockBtn = wwwStockpileHistorySwitch?.switch === 'yes';
    }
    return {
      props: {
        productResult,
        defaultAddressBelongWarehouse,
        wwwStockpileHistorySwitch,
        resourceData,
        websiteSectionList,
        headerAd,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error('Error in getStaticProps:', error);
    return {
      notFound: true,
      revalidate: 1,
    };
  }
}

export default HotProductDetailPage;
